export default "//uniclient-edge-assets.lmndstaging.com/jim-avatar-998ebf213cce08f434fb9d1a6bbbef7f.png"